if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      // alert('test');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
        console.log('text');
        console.log(responseText);
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      setTimeout(function () {
          var color=$('input[name="Color"]:checked').val();
          $('input[name="Size"]').each(function(){
            var vari= color + ' / '+ $(this).val();
            var id=$(this).attr('id');
            vari = vari.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var checkAvail=$('.vari-'+vari).val();
            console.log(id+' '+checkAvail + vari);
            if($('.vari-'+vari).length) {
                $('#label-'+id).show();
                $('.available:first').trigger('click');
                
              }else{
                $('#label-'+id).hide();
              }
          });
        
          $('.color-value').text(color);
           $(".thumbnail-list__item").hide();
        //      var color = $(this).val();
          var count = 1;
         $(".thumbnail-list__item").each(function(){
            var dotdata = $(this).data('alt');
             if (dotdata.indexOf(color) >= 0){
                 $(this).show();
               $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("first-dots"+count);
               $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("fill-dots");
               $(this).addClass("first-dots"+count);
               count +=1;
             }
         })
          
        //   $('.slideshow__text').click(function(){
        //     $('video.mobile-img').trigger('play');
        //   });
        var variant_color = $('input[name="Color"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        var variant_size = $('input[name="Size"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        var checked_id = "vari-"+variant_color+"-"+variant_size;
        console.log(checked_id);
        if($("."+checked_id).val() == "true"){
          $("#klaviyo__custom").removeClass("waitlist-block");
          $("#klaviyo__custom").addClass("waitlist-none");
          $("#klaviyo__custom").hide();
          $(".product-form__submit").show();
        }
        else{
          if($("#"+checked_id).val() == "false"){
            $(".product-form__submit").hide();
            $("#klaviyo__custom").show();
            $("#klaviyo__custom").addClass("waitlist-block");
            $("#klaviyo__custom").removeClass("waitlist-none");
          }
        }
      
      },1000)
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }
    
    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
